import { MAX_QUESTION_LENGTH } from './constants'
import { SlideQuestionErrorKeys } from './keys'
import { type ValidationError, type Validator } from './types'

export const validateModerationTask: Validator = async (context, question) => {
  const errors: ValidationError[] = []
  const trimmedQuestion = question.question?.trim()

  if (!trimmedQuestion) {
    errors.push({
      field: 'question',
      key: SlideQuestionErrorKeys.question_moderation_task_missing,
    })
  } else if (trimmedQuestion.length > MAX_QUESTION_LENGTH) {
    errors.push({
      field: 'question',
      key: SlideQuestionErrorKeys.question_moderation_task_too_long,
    })
  }

  return errors
}
